import { z } from 'zod'

export const SoftwareSchema = z.object({
  id: z.number(),
  name: z.string(),
  appstream_app_name: z.string(),
  is_latest: z.boolean(),
  created_at: z.string(),
  updated_at: z.string()
})

export type Software = z.infer<typeof SoftwareSchema>
